import useSWR from 'swr';

import { AgentApiRequestHelper } from '../agent-api-request-helper';
import type {
  IDocumentReaderUploadLimits,
  IDocumentReaderUploadLimitsResponse,
} from './types';

/** Whether this user may upload a data room, and the limits that apply. The route answers 404 with the
 * reader's flag off and 403 for non-staff, so any error reads as not allowed. */
export function useDocumentReaderUploadLimits(isEnabled: boolean): {
  uploadLimits: IDocumentReaderUploadLimits | null;
  isLoading: boolean;
  error: unknown;
} {
  const { data, isLoading, error } = useSWR(
    isEnabled ? 'agent-platform/document-reader/upload-limits' : null,
    (path: string) =>
      AgentApiRequestHelper.read<IDocumentReaderUploadLimitsResponse>(path),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
      shouldRetryOnError: false,
    }
  );

  return {
    uploadLimits: error ? null : (data?.uploadLimits ?? null),
    isLoading: isEnabled && isLoading,
    error,
  };
}
